import React from 'react'

import Layout from '../components/layout'
import { Column, Columns, Content, Section, Title } from 'bloomerjs'
import { graphql } from 'gatsby'
import Seo from '../components/Seo'

const AboutPage = ({ pageContext: { locale }, data, path }) => {
  const {
    title,
    paragraphs,
    quote,
    quoteAuthor,
    quoteTitle,
  } = data.file.childAboutJson
  return (
    <Layout locale={locale} path={path}>
      <Seo
        title={title}
        description={
          'Learn about how AvoVietnam got started and where we are going'
        }
      />
      <Content>
        <Section>
          <Title>{title}</Title>
          {paragraphs.map(paragraph => {
            return <p dangerouslySetInnerHTML={{ __html: paragraph }}></p>
          })}
          <p>{quoteTitle}</p>
          <Columns isCentered={true}>
            <Column isSize={'1/2'}>
              <blockquote>
                <p>{quote}</p>
                <p>{quoteAuthor}</p>
              </blockquote>
            </Column>
          </Columns>
        </Section>
      </Content>
    </Layout>
  )
}

export const query = graphql`
  query About($locale: String) {
    file(name: { eq: $locale }, relativeDirectory: { eq: "about" }) {
      childAboutJson {
        title
        paragraphs
        quoteTitle
        quote
        quoteAuthor
      }
    }
  }
`

export default AboutPage
